<template>
  <div class="bars">
    <div
      v-for="i in 3"
      :key="i"
      class="bar"
      :style="barStyle(i)"
    ></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class QualificationLevelBars extends Vue {
  @Prop({ required: true }) level!: 1 | 2 | 3;

  get color() {
    const map: Record<1 | 2 | 3, string> = {
      1: '#e5e7eb',
      2: '#9ca3af',
      3: '#4b5563',
    };
    return map[this.level];
  }

  barStyle(i: number) {
    const active = i <= this.level;
    return {
      backgroundColor: this.color,
      opacity: active ? 1 : 0.3,
    };
  }
}
</script>

<style scoped>
.bars {
  display: flex;
  align-items: center;
  column-gap: 2px;
}

.bar {
  width: 4px;
  height: 12px;
  border-radius: 2px;
}
</style>
